import type { Route as LinkRoute } from 'next';

export interface Route {
  to: LinkRoute;
  name: string;
  footer?: boolean; // true if the route should be in footer too
  header?: boolean; // true if the route should be in header too
  isFooterVisible?: boolean;
  isNewsletterVisible?: boolean;
  /**
   * NMRium pages have a different layout.
   * They set a height to be 100% of the dvh on the layout's root element.
   */
  isNmrium?: boolean;
  isNew?: boolean;
  isWhite?: boolean;
  embedded?: boolean;
}

const routes: Route[] = [
  {
    to: '/',
    name: 'Home',
    footer: true,
    header: true,
    isFooterVisible: true,
    embedded: false,
    // Manually added to the page instead of footer
    isNewsletterVisible: false,
  },
  {
    to: '/nmrium',
    name: 'NMRium',
    footer: true,
    header: true,
    isFooterVisible: false,
    isNmrium: true,
    isWhite: true,
    embedded: false,
    isNewsletterVisible: false,
  },
  {
    to: '/nmrium/embed',
    name: 'NMRium embed',
    footer: false,
    header: false,
    isFooterVisible: false,
    isWhite: true,
    embedded: true,
    isNmrium: true,
    isNewsletterVisible: false,
  },
  {
    to: '/features',
    name: 'Features',
    footer: true,
    header: true,
    isFooterVisible: false,
    isWhite: false,
    embedded: false,
    isNewsletterVisible: false,
  },
  {
    to: '/teaching',
    name: 'Teaching',
    footer: true,
    header: true,
    isFooterVisible: true,
    isWhite: true,
    embedded: false,
    isNewsletterVisible: true,
  },
  {
    to: '/teaching/exercises',
    name: 'Exercises',
    header: false,
    footer: true,
    isFooterVisible: false,
    isNmrium: true,
    isWhite: true,
    embedded: false,
    isNewsletterVisible: false,
  },
  {
    to: '/tutorials',
    name: 'Tutorials',
    footer: true,
    header: true,
    isFooterVisible: false,
    isWhite: false,
    embedded: false,
    isNewsletterVisible: false,
  },
  {
    to: '/pricing',
    name: 'Pricing',
    footer: true,
    header: true,
    isFooterVisible: true,
    isWhite: true,
    embedded: false,
    isNewsletterVisible: false,
  },
  {
    to: '/pricing/request',
    name: 'Order',
    footer: false,
    header: false,
    isFooterVisible: false,
    isWhite: true,
  },
  {
    to: '/pricing/request/success',
    name: 'Order success',
    footer: false,
    header: false,
    isFooterVisible: false,
    isWhite: true,
  },
  {
    to: '/prediction',
    name: 'Prediction',
    footer: false,
    header: false,
    isFooterVisible: false,
    isWhite: true,
    embedded: false,
    isNewsletterVisible: false,
    isNmrium: true,
  },
  {
    to: '/predict' as LinkRoute,
    name: 'Predict',
    footer: false,
    header: false,
    isFooterVisible: false,
    isWhite: true,
    embedded: false,
    isNmrium: true,
    isNewsletterVisible: false,
  },
  {
    to: '/predict/embed',
    name: 'Predict embed',
    footer: false,
    header: false,
    isFooterVisible: false,
    isWhite: true,
    embedded: true,
    isNewsletterVisible: false,
  },
  {
    to: '/simulation',
    name: 'Simulation',
    footer: false,
    header: false,
    isFooterVisible: false,
    isWhite: true,
    embedded: false,
    isNewsletterVisible: false,
    isNmrium: true,
  },
  {
    to: '/about',
    name: 'About us',
    footer: true,
    header: false,
    isFooterVisible: true,
    isWhite: false,
    embedded: false,
    isNewsletterVisible: true,
  },
  {
    to: '/contact',
    name: 'Contact us',
    footer: true,
    header: true,
    isFooterVisible: true,
    isWhite: false,
    embedded: false,
    isNewsletterVisible: false,
  },
];

export default routes;
export const footer = routes.filter((r) => r.footer);
